import { SvelteComponent, init, safe_not_equal, element, attr, insert, add_render_callback, create_out_transition, detach, create_slot, text, set_data, space, toggle_class, append, listen, stop_propagation, transition_in, transition_out, check_outros, update_slot_base, get_all_dirty_from_scope, get_slot_changes, run_all, createEventDispatcher, create_in_transition, group_outros } from '../../../../external_node_modules/svelte/internal/index.mjs.js';
import { fade } from '../../../../external_node_modules/svelte/transition/index.mjs.js';
import { playButtonClickSound } from '../../../../external_node_modules/@wg/web2clientapi/sound/index.js';
import { isIngame } from '../../../../external_node_modules/@wg/web2clientapi/utils/checkIngame.js';
import { ButtonTheme } from '../../../../interfaces/ButtonTheme.js';
import './Button.css.js';

/* src/ui/shared/components/Button/Button.svelte generated by Svelte v3.44.2 */

function create_if_block(ctx) {
	let span;
	let span_intro;
	let span_outro;
	let current;

	return {
		c() {
			span = element("span");
			attr(span, "class", "tile-button__loader wcl-l8nkts");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			current = true;
		},
		i(local) {
			if (current) return;

			add_render_callback(() => {
				if (span_outro) span_outro.end(1);
				span_intro = create_in_transition(span, fade, { duration: 150 });
				span_intro.start();
			});

			current = true;
		},
		o(local) {
			if (span_intro) span_intro.invalidate();
			span_outro = create_out_transition(span, fade, { duration: 150 });
			current = false;
		},
		d(detaching) {
			if (detaching) detach(span);
			if (detaching && span_outro) span_outro.end();
		}
	};
}

// (37:10) {content !== undefined ? content : ''}
function fallback_block(ctx) {
	let t_value = (/*content*/ ctx[0] !== undefined
	? /*content*/ ctx[0]
	: '') + "";

	let t;

	return {
		c() {
			t = text(t_value);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*content*/ 1 && t_value !== (t_value = (/*content*/ ctx[0] !== undefined
			? /*content*/ ctx[0]
			: '') + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

function create_fragment(ctx) {
	let button;
	let t;
	let span;
	let current;
	let mounted;
	let dispose;
	let if_block = /*loading*/ ctx[4] && create_if_block();
	const default_slot_template = /*#slots*/ ctx[9].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[8], null);
	const default_slot_or_fallback = default_slot || fallback_block(ctx);

	return {
		c() {
			button = element("button");
			if (if_block) if_block.c();
			t = space();
			span = element("span");
			if (default_slot_or_fallback) default_slot_or_fallback.c();
			attr(span, "class", "tile-button__label wcl-l8nkts");
			attr(button, "class", "tile-button wcl-l8nkts");
			attr(button, "theme", /*theme*/ ctx[5]);
			toggle_class(button, "tile-button--outline", /*outline*/ ctx[1]);
			toggle_class(button, "tile-button--outline-rounded", /*outlineRounded*/ ctx[2]);
			toggle_class(button, "tile-button--disabled", /*disabled*/ ctx[3]);
			toggle_class(button, "tile-button--loading", /*loading*/ ctx[4]);
		},
		m(target, anchor) {
			insert(target, button, anchor);
			if (if_block) if_block.m(button, null);
			append(button, t);
			append(button, span);

			if (default_slot_or_fallback) {
				default_slot_or_fallback.m(span, null);
			}

			current = true;

			if (!mounted) {
				dispose = [
					listen(button, "click", stop_propagation(/*onClick*/ ctx[7])),
					listen(button, "mousedown", /*onMousedown*/ ctx[6])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (/*loading*/ ctx[4]) {
				if (if_block) {
					if (dirty & /*loading*/ 16) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block();
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(button, t);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			if (default_slot) {
				if (default_slot.p && (!current || dirty & /*$$scope*/ 256)) {
					update_slot_base(
						default_slot,
						default_slot_template,
						ctx,
						/*$$scope*/ ctx[8],
						!current
						? get_all_dirty_from_scope(/*$$scope*/ ctx[8])
						: get_slot_changes(default_slot_template, /*$$scope*/ ctx[8], dirty, null),
						null
					);
				}
			} else {
				if (default_slot_or_fallback && default_slot_or_fallback.p && (!current || dirty & /*content*/ 1)) {
					default_slot_or_fallback.p(ctx, !current ? -1 : dirty);
				}
			}

			if (!current || dirty & /*theme*/ 32) {
				attr(button, "theme", /*theme*/ ctx[5]);
			}

			if (dirty & /*outline*/ 2) {
				toggle_class(button, "tile-button--outline", /*outline*/ ctx[1]);
			}

			if (dirty & /*outlineRounded*/ 4) {
				toggle_class(button, "tile-button--outline-rounded", /*outlineRounded*/ ctx[2]);
			}

			if (dirty & /*disabled*/ 8) {
				toggle_class(button, "tile-button--disabled", /*disabled*/ ctx[3]);
			}

			if (dirty & /*loading*/ 16) {
				toggle_class(button, "tile-button--loading", /*loading*/ ctx[4]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			transition_in(default_slot_or_fallback, local);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			transition_out(default_slot_or_fallback, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(button);
			if (if_block) if_block.d();
			if (default_slot_or_fallback) default_slot_or_fallback.d(detaching);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	let { content } = $$props;
	let { outline } = $$props;
	let { outlineRounded } = $$props;
	let { disabled } = $$props;
	let { loading } = $$props;
	let { theme = ButtonTheme.primary } = $$props;
	const dispatch = createEventDispatcher();

	function onMousedown() {
		if (isIngame()) {
			playButtonClickSound();
		}
	}

	function onClick() {
		dispatch(disabled ? 'clickDisabled' : 'click');
	}

	$$self.$$set = $$props => {
		if ('content' in $$props) $$invalidate(0, content = $$props.content);
		if ('outline' in $$props) $$invalidate(1, outline = $$props.outline);
		if ('outlineRounded' in $$props) $$invalidate(2, outlineRounded = $$props.outlineRounded);
		if ('disabled' in $$props) $$invalidate(3, disabled = $$props.disabled);
		if ('loading' in $$props) $$invalidate(4, loading = $$props.loading);
		if ('theme' in $$props) $$invalidate(5, theme = $$props.theme);
		if ('$$scope' in $$props) $$invalidate(8, $$scope = $$props.$$scope);
	};

	return [
		content,
		outline,
		outlineRounded,
		disabled,
		loading,
		theme,
		onMousedown,
		onClick,
		$$scope,
		slots
	];
}

class Button extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			content: 0,
			outline: 1,
			outlineRounded: 2,
			disabled: 3,
			loading: 4,
			theme: 5
		});
	}
}

export { Button as default };
//# sourceMappingURL=Button.svelte.js.map
